import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Check for existing end time in localStorage
    const storedEndTime = localStorage.getItem('magneticMethodTimer');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      // If timer expired, reset it for another 24h (simulated evergreen launch)
      if (Date.now() > endTime) {
        endTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('magneticMethodTimer', endTime.toString());
      }
    } else {
      // Set new 24h timer
      endTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('magneticMethodTimer', endTime.toString());
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        // Reset if expired
        const newEndTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('magneticMethodTimer', newEndTime.toString());
        setTimeLeft({
          hours: 23,
          minutes: 59,
          seconds: 59
        });
      } else {
        const hours = Math.floor(difference / (1000 * 60 * 60) % 24);
        const minutes = Math.floor(difference / 1000 / 60 % 60);
        const seconds = Math.floor(difference / 1000 % 60);
        setTimeLeft({
          hours,
          minutes,
          seconds
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center space-y-2" data-id="element-279">
      <div className="flex items-center space-x-2 text-urgency font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-280">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-281" />
        <span data-id="element-282">PRECIO DE LANZAMIENTO termina en:</span>
      </div>

      <div className="flex items-center space-x-1 md:space-x-2 text-3xl md:text-4xl font-heading font-bold text-white tabular-nums" data-id="element-283">
        <motion.div key={timeLeft.hours} initial={{
        y: -5,
        opacity: 0.5
      }} animate={{
        y: 0,
        opacity: 1
      }} className="bg-bg-card border border-border-color px-2 md:px-3 py-1 rounded-lg shadow-inner" data-id="element-284">
          {formatNumber(timeLeft.hours)}
        </motion.div>
        <span className="text-border-color" data-id="element-285">:</span>
        <motion.div key={timeLeft.minutes} initial={{
        y: -5,
        opacity: 0.5
      }} animate={{
        y: 0,
        opacity: 1
      }} className="bg-bg-card border border-border-color px-2 md:px-3 py-1 rounded-lg shadow-inner" data-id="element-286">
          {formatNumber(timeLeft.minutes)}
        </motion.div>
        <span className="text-border-color" data-id="element-287">:</span>
        <motion.div key={timeLeft.seconds} initial={{
        y: -5,
        opacity: 0.5
      }} animate={{
        y: 0,
        opacity: 1
      }} className="bg-bg-card border border-border-color px-2 md:px-3 py-1 rounded-lg shadow-inner text-urgency" data-id="element-288">
          {formatNumber(timeLeft.seconds)}
        </motion.div>
      </div>

      <p className="text-xs md:text-sm text-text-secondary" data-id="element-289">
        Bonos incluidos mientras el contador esté activo.
      </p>
    </div>;
}